import transform from "lodash/transform";
import { Enums } from "@flightscope/baseball-stats";
import CommonColorMapping from "./CommonColorMapping";
import PitchCallSeriesColorMapping2025 from "./PitchCallSeriesColorMapping2025";
import getColorForPitchResultCombined from "./helpers/getColorForPitchResultCombined";

const PitchResultCombinedColorMapping = transform(
  Enums.PitchResultCombined,
  (acc, curr) => {
    const { key } = curr;
    acc[key] = getColorForPitchResultCombined(key, curr, PitchCallSeriesColorMapping2025);
    return acc;
  },
  { ...CommonColorMapping }
);

export default PitchResultCombinedColorMapping;
